import React from 'react';
import { Link } from 'react-router-dom';
import banner from '../../assets/images/background/bg-shape-1-dark.jpg';
import neftimg from '../../assets/images/misc/nft.png';
import collimg1 from '../../assets/images/collections/coll-1.jpg';
import authorimg1 from '../../assets/images/author/author-1.jpg';
import collimg2 from '../../assets/images/collections/coll-2.jpg';
import authorimg2 from '../../assets/images/author/author-2.jpg';
import collimg3 from '../../assets/images/collections/coll-3.jpg';
import authorimg3 from '../../assets/images/author/author-3.jpg';
import collimg4 from '../../assets/images/collections/coll-4.jpg';
import authorimg4 from '../../assets/images/author/author-4.jpg';
import collimg5 from '../../assets/images/collections/coll-5.jpg';
import authorimg5 from '../../assets/images/author/author-5.jpg';
import collimg6 from '../../assets/images/collections/coll-6.jpg';
import authorimg6 from '../../assets/images/author/author-6.jpg';
import authorimg7 from '../../assets/images/author/author-7.jpg';
import authorimg8 from '../../assets/images/author/author-8.jpg';
import authorimg9 from '../../assets/images/author/author-9.jpg';
import authorimg10 from '../../assets/images/author/author-10.jpg';
import authorimg11 from '../../assets/images/author/author-11.jpg';
import authorimg12 from '../../assets/images/author/author-12.jpg';

const Home = () => {
    return (
        <div className="no-bottom no-top" id="content">
            <div id="top"></div>
            <section id="section-hero" aria-label="section" className="no-top no-bottom vh-100" style={{ backgroundImage: `url("${banner}")` }}>
                <div className="v-center">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <div className="spacer-single"></div>
                                <h6 className="wow fadeInUp" data-wow-delay=".5s">
                                    <span className="text-uppercase id-color-2">NFT Exchange</span>
                                </h6>
                                <div className="spacer-10"></div>
                                <h1 className="wow fadeInUp" data-wow-delay=".75s">
                                    Create, sell or collect digital items.
                                </h1>
                                <p className="wow fadeInUp lead" data-wow-delay="1s">
                                    Unit of data stored on a digital ledger, called a blockchain, that certifies a digital asset to be unique and
                                    therefore not interchangeable
                                </p>
                                <div className="spacer-10"></div>
                                <Link to="/explore" className="btn-main wow fadeInUp lead" data-wow-delay="1.25s">
                                    Explore
                                </Link>
                                <div className="mb-sm-30"></div>
                            </div>
                            <div className="col-md-6 xs-hide">
                                <img src={neftimg} className="lazy img-fluid wow fadeIn" data-wow-delay="1.25s" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="section-intro" className="no-top no-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-sm-30">
                            <div className="feature-box f-boxed style-3">
                                <i className="wow fadeInUp bg-color-2 i-boxed icon_wallet"></i>
                                <div className="text">
                                    <h4 className="wow fadeInUp">Set up your wallet</h4>
                                    <p className="wow fadeInUp" data-wow-delay=".25s">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem.
                                    </p>
                                </div>
                                <i className="wm icon_wallet"></i>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-sm-30">
                            <div className="feature-box f-boxed style-3">
                                <i className="wow fadeInUp bg-color-2 i-boxed icon_cloud-upload_alt"></i>
                                <div className="text">
                                    <h4 className="wow fadeInUp">Add your NFT's</h4>
                                    <p className="wow fadeInUp" data-wow-delay=".25s">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem.
                                    </p>
                                </div>
                                <i className="wm icon_cloud-upload_alt"></i>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-sm-30">
                            <div className="feature-box f-boxed style-3">
                                <i className="wow fadeInUp bg-color-2 i-boxed icon_tags_alt"></i>
                                <div className="text">
                                    <h4 className="wow fadeInUp">Trade your NFT's</h4>
                                    <p className="wow fadeInUp" data-wow-delay=".25s">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem.
                                    </p>
                                </div>
                                <i className="wm icon_tags_alt"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="section-collections" className="no-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <h2>Featured Collections</h2>
                                <div className="small-border bg-color-2"></div>
                            </div>
                        </div>
                        <div id="collection-carousel" className="owl-carousel wow fadeIn">
                            <div className="nft_coll">
                                <div className="nft_wrap">
                                    <Link to="/collection">
                                        <img src={collimg1} className="lazy img-fluid" alt="" />
                                    </Link>
                                </div>
                                <div className="nft_coll_pp">
                                    <Link to="/collection">
                                        <img className="lazy" src={authorimg1} alt="" />
                                    </Link>
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="nft_coll_info">
                                    <Link to="/collection">
                                        <h4>Abstraction</h4>
                                    </Link>
                                    <span>ERC-192</span>
                                </div>
                            </div>

                            <div className="nft_coll">
                                <div className="nft_wrap">
                                    <Link to="/collection">
                                        <img src={collimg2} className="lazy img-fluid" alt="" />
                                    </Link>
                                </div>
                                <div className="nft_coll_pp">
                                    <Link to="/collection">
                                        <img className="lazy" src={authorimg2} alt="" />
                                    </Link>
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="nft_coll_info">
                                    <Link to="/collection">
                                        <h4>Patternlicious</h4>
                                    </Link>
                                    <span>ERC-61</span>
                                </div>
                            </div>

                            <div className="nft_coll">
                                <div className="nft_wrap">
                                    <Link to="/collection">
                                        <img src={collimg3} className="lazy img-fluid" alt="" />
                                    </Link>
                                </div>
                                <div className="nft_coll_pp">
                                    <Link to="/collection">
                                        <img className="lazy" src={authorimg3} alt="" />
                                    </Link>
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="nft_coll_info">
                                    <Link to="/collection">
                                        <h4>Skecthify</h4>
                                    </Link>
                                    <span>ERC-126</span>
                                </div>
                            </div>

                            <div className="nft_coll">
                                <div className="nft_wrap">
                                    <Link to="/collection">
                                        <img src={collimg4} className="lazy img-fluid" alt="" />
                                    </Link>
                                </div>
                                <div className="nft_coll_pp">
                                    <Link to="/collection">
                                        <img className="lazy" src={authorimg4} alt="" />
                                    </Link>
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="nft_coll_info">
                                    <Link to="/collection">
                                        <h4>Cartoonism</h4>
                                    </Link>
                                    <span>ERC-73</span>
                                </div>
                            </div>

                            <div className="nft_coll">
                                <div className="nft_wrap">
                                    <Link to="/collection">
                                        <img src={collimg5} className="lazy img-fluid" alt="" />
                                    </Link>
                                </div>
                                <div className="nft_coll_pp">
                                    <Link to="/collection">
                                        <img className="lazy" src={authorimg5} alt="" />
                                    </Link>
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="nft_coll_info">
                                    <Link to="/collection">
                                        <h4>Virtuland</h4>
                                    </Link>
                                    <span>ERC-85</span>
                                </div>
                            </div>

                            <div className="nft_coll">
                                <div className="nft_wrap">
                                    <Link to="/collection">
                                        <img src={collimg6} className="lazy img-fluid" alt="" />
                                    </Link>
                                </div>
                                <div className="nft_coll_pp">
                                    <Link to="/collection">
                                        <img className="lazy" src={authorimg6} alt="" />
                                    </Link>
                                    <i className="fa fa-check"></i>
                                </div>
                                <div className="nft_coll_info">
                                    <Link to="/collection">
                                        <h4>Papercut</h4>
                                    </Link>
                                    <span>ERC-42</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="section-popular" className="pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <h2>Top Collections</h2>
                                <div className="small-border bg-color-2"></div>
                            </div>
                        </div>
                        <div className="button-group-wrapper">
                            <div className="row justify-content-between">
                                <div className="col-md-4 col-lg-6 col-xl-5">
                                    <div className="sort-by">
                                        <span>Sort By:</span>
                                        {/* <button className="btn-sales-value">Sales Volume</button> */}
                                        <div id="item_category" className="dropdown">
                                            <Link to="/" className="btn-selector">
                                                Sales Volume
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-lg-6 col-xl-7">
                                    <div className="button-info">
                                        <button className="common-button current">Today</button>
                                        <button className="common-button">Last 7 Days</button>
                                        <button className="common-button">Last 30 Days</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 wow fadeIn">
                            <ol className="author_list">
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg1} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Monica Lucas</Link>
                                        <span>3.2 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg2} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Mamie Barnett</Link>
                                        <span>2.8 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg3} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Nicholas Daniels</Link>
                                        <span>2.5 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg4} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Lori Hart</Link>
                                        <span>2.2 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg5} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Jimmy Wright</Link>
                                        <span>1.9 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg6} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Karla Sharp</Link>
                                        <span>1.6 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg7} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Gayle Hicks</Link>
                                        <span>1.5 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg8} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Claude Banks</Link>
                                        <span>1.3 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg9} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Franklin Greer</Link>
                                        <span>0.9 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg10} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Stacy Long</Link>
                                        <span>0.8 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg11} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Ida Chapman</Link>
                                        <span>0.6 ETH</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="author_list_pp">
                                        <Link to="/">
                                            <img className="lazy" src={authorimg12} alt="" />
                                            <i className="fa fa-check"></i>
                                        </Link>
                                    </div>
                                    <div className="author_list_info">
                                        <Link to="/">Fred Ryan</Link>
                                        <span>0.5 eth</span>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
